var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"field",attrs:{"append-icon":"mdi-magnify","label":"Найти"},model:{value:(_vm.find),callback:function ($$v) {_vm.find=$$v},expression:"find"}})}
var staticRenderFns = []

export { render, staticRenderFns }